import { datadogRum } from '@datadog/browser-rum';

export default ({ app }) => {
  app.router.afterEach((to) => {
    if (datadogRum && typeof datadogRum.startView === 'function') {
      if (to.path === '/upsells' || to.path.startsWith('/upsells')) {
        datadogRum.startView(`${to.path}`);
      }
    }
  });
};
